import React from 'react';
import { Box, Typography } from '@mui/material';

interface StatisticsBlockProps {
    title: string;
    children: React.ReactNode;
}

export const StatisticsBlock: React.FC<StatisticsBlockProps> = ({ title, children }) => {
    return (
        <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1A2229' }}>
                {title}
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gap: 2 }}>
                {children}
            </Box>
        </Box>
    );
};

